<template>
    <div class="dropdown float-left">
        <button type="button" :disabled="foundationLoading"
                class="py-2 px-3 standard-dropdown border-1 border-teal hover:bg-followup-nav  rounded-full hover:text-white mx-1 text-teal text-followup-nav focus:outline-none"
                id="foundationOptionDropDown" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false">
            <i  style="display: none;" class="fa fa-spin fa-spinner text-grey-darkest foundation-project-loader" aria-hidden="true"></i>
            Foundation Options <i class="fa fa-caret-down mx-1"></i>
        </button>
        <div class="standard-dropdown dropdown-menu dropdown-menu-right" aria-labelledby="foundationOptionDropDown">
            <button v-if="canErpCreate" type="button" class="dropdown-item py-2" :disabled="foundationProjectMapping.direction === 'one-way-followup' || project.foundation_project_no" @click.prevent.stop="pushProjectToFoundation">
                Connect/Push to Foundation
            </button>
            <button v-if="canErpUpdate" type="button" class="dropdown-item py-2" :disabled="foundationProjectMapping.direction === 'one-way-followup' || !project.foundation_project_no" @click.prevent.stop="pushOrUpdateProjectToFoundation(null)">
                Update Job on Foundation
            </button>
            <button v-if="canErpSync" type="button" class="dropdown-item py-2" :disabled="foundationProjectMapping.direction === 'one-way-third-party'"  @click.prevent="syncProjectFromFoundation">
                Sync from Foundation
            </button>
        </div>

        <!-- Connect/Push to Foundation Modal -->
        <div class="modal" id="foundationCustomerSelectionModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title text-teal font-medium">Select Contact</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeFoundationModal('foundationCustomerSelectionModal', false, true)">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <label for="user">Select contact to associate with the Foundation Job</label>
                                <multiselect
                                    class="cursor-pointer w-full"
                                    :options="companyContacts"
                                    v-model="selectedCustomerForFoundationJob"
                                    label="name"
                                    placeholder="Search and Select..."
                                    :multiple="false"
                                    track-by="id"
                                    :show-labels="false"
                                    :taggable="true"
                                    :close-on-select="true"
                                    @input="selectedCustomerForFoundationJobChanged"
                                >
                                </multiselect>
                            </div>
                        </div>
                        <div v-if="selectedCustomerForFoundationJob && selectedCustomerForFoundationJob.foundation_customer_contact_no" class="text-sm mb-3 text-teal">The contact is synced already</div>
                        <div v-if="selectedCustomerForFoundationJob && !selectedCustomerForFoundationJob.foundation_customer_contact_no" class="text-sm mb-3 text-teal">Note: You have selected a contact that is not synced with Foundation. Clicking on Push will link the contact to an existing customer on Foundation if the email address matches. If email address does not match, a new customer will be created on Foundation.</div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeFoundationModal('foundationCustomerSelectionModal', false, true)">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="checkCustomerFoundationStatus" :disabled="!this.selectedCustomerForFoundationJob">Select</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Update on Foundation Modal -->
        <div class="modal" tabindex="-1" role="dialog" id="updateFoundationJobModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">WARNING! - This will over-write the info of the Synced Foundation Job.</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>This will replace or update the Foundation Job that is synced with this project. Are you sure you want to proceed?</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="closeFoundationModal('updateFoundationJobModal')">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="updateJobOnFoundation">Confirm</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="syncFoundationJobConfirmModal">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">WARNING! - This will over-write some of the Project fields.</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>This will overwrite certain fields of this project with info from the Foundation Job.</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="closeFoundationModal('syncFoundationJobConfirmModal')">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="pullJobFromFoundation">Confirm</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="syncJobFromFoundationModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title text-teal font-medium" v-if="!syncFromFoundationStepTwo">This project is not synced with a Foundation Job</h5>
                        <h5 class="modal-title text-teal font-medium" v-else>WARNING! - This will over-write some of the Project fields.</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeFoundationModal('syncJobFromFoundationModal', true)">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row" v-if="!syncFromFoundationStepTwo">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <label for="user">Select the Foundation Job to sync this project with</label>
                                <multiselect
                                    v-model="selectedFoundationJob"
                                    :options="jobsFromFoundation"
                                    @search-change="onSyncFoundationInput"
                                    label="name"
                                    :loading="fetchingFoundationJobs"
                                    track-by="source_id"
                                    :multiple="false"
                                    placeholder="Search Foundation job..."
                                    :closeOnSelect="true">
                                    <template #spinner>
                                        <span>Loading...</span>
                                    </template>
                                </multiselect>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
                                <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeFoundationModal('syncJobFromFoundationModal', true)">Cancel</button>
                                <button type="button" class="btn btn-primary" :disabled="!selectedFoundationJob" @click.prevent="() => syncFromFoundationStepTwo = true">Next</button>
                            </div>
                        </div>
                        <div class="row" v-else>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <p>This will overwrite certain fields of this project with info from the Foundation Job.</p>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
                                <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeFoundationModal('syncJobFromFoundationModal', true)">Cancel</button>
                                <button type="button" class="btn btn-primary" :disabled="!selectedFoundationJob" @click.prevent="pullJobFromFoundation">Confirm</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="updateFoundationSyncedCustomerConfirmModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">WARNING! - This will over-write the info of the Synced Foundation Customer.</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>This company along with another contact "{{(this.selectedCustomerForFoundationJob && this.selectedCustomerForFoundationJob.other_synced_contact_with_foundation) ? this.selectedCustomerForFoundationJob.other_synced_contact_with_foundation.name : ''}}" is currently linked with Foundation
                            customer with customer number "{{(this.selectedCustomerForFoundationJob && this.selectedCustomerForFoundationJob.other_synced_contact_with_foundation) ? this.selectedCustomerForFoundationJob.other_synced_contact_with_foundation.foundation_customer_contact_no : ''}}". Would you like to overwrite the contact details on Foundation with the contact "{{this.selectedCustomerForFoundationJob ? this.selectedCustomerForFoundationJob.name : ''}}"?</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="syncedOtherCompanyContactToFoundation();closeFoundationModal('updateFoundationSyncedCustomerConfirmModal')">No</button>
                        <button type="button" class="btn btn-primary" @click.prevent="updateSyncedCustomerOnFoundation();closeFoundationModal('updateFoundationSyncedCustomerConfirmModal');">Yes</button>
                    </div>
                </div>
            </div>
        </div>


        <div class="modal" tabindex="-1" role="dialog" id="pushProjectWithOutCompanyModal">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">WARNING! - This will over-write the info of the Synced Foundation Customer.</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>You have not mapped the company/residential contact field in the ERP settings. Would you like to create a Foundation job without a customer associated?</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="closeFoundationModal('pushProjectWithOutCompanyModal')">No</button>
                        <button type="button" class="btn btn-primary" @click.prevent="closeFoundationModal('pushProjectWithOutCompanyModal');pushProjectWithCustomer(false);">Yes</button>
                    </div>
                </div>
            </div>
        </div>


        <div class="modal" id="syncJobFromFoundationForChangeOrderModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title text-teal font-medium">Select Foundation Job</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeFoundationModal('syncJobFromFoundationForChangeOrderModal')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <label for="user">This project is currently not synced with Foundation. Please select a Job on Foundation to sync this with</label>
                                <multiselect
                                    v-model="selectedFoundationJobForChangeOrders"
                                    :options="jobsFromFoundation"
                                    @search-change="onSyncFoundationInput"
                                    label="name"
                                    :loading="fetchingFoundationJobs"
                                    track-by="source_id"
                                    :multiple="false"
                                    placeholder="Search Foundation job..."
                                    :closeOnSelect="true">
                                    <template #spinner>
                                        <span>Loading...</span>
                                    </template>
                                </multiselect>

                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
                                <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeFoundationModal('syncJobFromFoundationForChangeOrderModal')">Cancel</button>
                                <button v-if="isFetchingJobChangeOrders" type="button" class="btn btn-primary" :disabled="true" @click.prevent="fetchJobChangeOrders">
                                    <i class="fa fa-spin fa-spinner text-grey-darkest foundation-project-loader" aria-hidden="true"></i>
                                    Fetching job change orders...
                                </button>
                                <button v-else type="button" class="btn btn-primary" :disabled="!selectedFoundationJobForChangeOrders" @click.prevent="fetchJobChangeOrders">Select</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="syncFoundationChangeOrderModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title text-teal font-medium">Select Foundation Change Order</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeFoundationModal('syncFoundationChangeOrderModal')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <label for="user">Select Foundation Change Order</label>
                                <multiselect
                                    v-model="selectedFoundationChangeOrder"
                                    :options="jobChangeOrders"
                                    label="number"
                                    track-by="id"
                                    :multiple="false"
                                    placeholder="Select Foundation Change Order..."
                                    :closeOnSelect="true"
                                >
                                </multiselect>

                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
                                <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeFoundationModal('syncFoundationChangeOrderModal')">Cancel</button>
                                <button type="button" class="btn btn-primary" :disabled="!selectedFoundationChangeOrder" @click.prevent="closeFoundationModal('syncFoundationChangeOrderModal');openFoundationModal('updateFoundationSyncedChangeOrderConfirmModal')">Select</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="updateFoundationSyncedChangeOrderConfirmModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">WARNING! - Replace Change Order fields with data from Foundation?</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>This will pull in data from a Change Order in Foundation and replace the fields on Followup, based on the fields mapped in the settings.</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger" @click.prevent="syncJobChangeOrder()">Confirm</button>
                        <button type="button" class="btn btn-primary" @click.prevent="closeFoundationModal('updateFoundationSyncedChangeOrderConfirmModal')">Cancel</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="customerCustomFieldNoModal">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">Foundation Custom Customer Number</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <label for="customCustomerNo" class="mb-1">{{ selectedCustomerData.customFieldLabel }}</label>
                                <input type="text" name="customCustomerNo" class="form-control appearance-none bg-white border-1 focus:outline-none leading-normal px-2 rounded shadow-sm text-grey-darkest tracking-wide w-full" v-model="selectedCustomerData.customFieldValue">
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click.prevent="closeFoundationModal('customerCustomFieldNoModal')">Cancel</button>
                        <button type="button" class="btn btn-primary" :disabled="!selectedCustomerData.customFieldValue" @click.prevent="pushToFoundation();closeFoundationModal('customerCustomFieldNoModal');">Push</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import axios from "axios";
import Multiselect from "vue-multiselect";

export default {
    name: 'project-foundation',
    components: {Multiselect},
    props: ['project', 'companyContacts', 'foundationJobNumberCustomFieldId', 'hasFoundationCompanyContactMapping', 'hasFoundationResidentialContactMapping', 'projectSalesStatusState', 'foundationProjectMapping', 'isProjectSequentialIdMappedToFoundation',
            'foundationCompanyCustomerCodeCustomField', 'foundationResidentialContactCustomerCodeCustomField', 'canErpCreate', 'canErpUpdate', 'canErpSync'],
    data() {
        return {
            selectedCustomerForFoundationJob: null,
            selectedFoundationJob: null,
            jobsFromFoundation: [],
            syncFromFoundationStepTwo: false,
            fetchingFoundationJobs: false,
            syncedOtherCompanyContact: null,
            updateCustomerContactInfo: false,
            customJobNumber: null,
            pushCustomerToFoundation: false,
            selectedFoundationJobForChangeOrders: null,
            selectedFoundationChangeOrder: null,
            jobChangeOrders: [],
            selectedProjectChangeOrderIndex: null,
            foundationLoading: false,
            checkJobNumberExistsOnFoundation: false,
            isFetchingJobChangeOrders: false,
            selectedCustomerData: {
                action: 'create',
                customFieldId: null,
                customFieldLabel: null,
                customFieldValue: null,
                isResidentialContact: false,
            },
            isCustomerEmailDomainExistsOnFoundation: false,
            pushSyncedOtherContact: false,
            foundationCompanyCustomerCodeCustomFieldValue: null,
            foundationResidentialContactCustomerCodeCustomFieldValue: null
        }
    },
    created() {
        this.debouncedFilterOptions = _.debounce(this.filterOptions, 500);
    },
    mounted() {
        $(document).ready(function() {
            // Initialize tooltip
            $('.custom-tooltip').tooltip();
        });
    },
    methods: {
        pushProjectToFoundation() {
            let self = this;

            if(this.foundationJobNumberCustomFieldId && !self.$parent.$refs.CustomFields.form[this.foundationJobNumberCustomFieldId] && self.$parent.$refs.CustomFields.form[this.foundationJobNumberCustomFieldId].trim() === "") {
                self.getToast().fire({
                    type: 'error',
                    title: 'Foundation Job # is required. Please enter the custom Job # in the custom job # field and try again..'
                });
            }
            else {
                let jobNumber = this.$parent.$refs.CustomFields.form[this.foundationJobNumberCustomFieldId] ?? null;
                this.pushOrUpdateProjectToFoundation(jobNumber);
            }
        },
        async pushOrUpdateProjectToFoundation(jobNumber = null) {
            this.customJobNumber = jobNumber;
            if(!this.customJobNumber && (this.project.foundation_project_no || this.project.agave_foundation_project_no)) {
                $('#updateFoundationJobModal').modal('show');
            }
            else {
                if(this.customJobNumber) {
                    await this.checkJobNoExistsOnFoundation(jobNumber);
                    if(this.checkJobNumberExistsOnFoundation) {
                        this.pushToFoundation();
                    }
                    else {
                        this.selectedCustomerForFoundationJob = null;
                        $('#foundationCustomerSelectionModal').modal('show');
                    }
                }
                else {
                    this.selectedCustomerForFoundationJob = null;
                    $('#foundationCustomerSelectionModal').modal('show');
                }
            }
        },
        syncProjectFromFoundation() {
            if(this.project.agave_foundation_project_no) {
                $('#syncFoundationJobConfirmModal').modal('show');
            }
            else {
                $('#syncJobFromFoundationModal').modal('show');
            }
        },
        syncProjectChangeOrdersFromFoundation(index) {
            this.selectedProjectChangeOrderIndex = index;
            if(this.project.agave_foundation_project_no) {
                this.fetchJobChangeOrders();
            }
            else {
                $('#syncJobFromFoundationForChangeOrderModal').modal('show');
            }
        },
        openFoundationModal(modalId) {
            $('#' + modalId).modal('show');
            if(modalId === 'foundationCustomerSelectionModal'){
                this.selectedCustomerForFoundationJob = null;
            }
        },
        closeFoundationModal(modalId, status = false, isCancelled = false) {
            if(modalId === 'syncJobFromFoundationModal' && status) {
                this.syncFromFoundationStepTwo = false;
                this.selectedFoundationJob = null;
                this.jobsFromFoundation = [];
            }
            $('#'+modalId).modal('hide');
            if(isCancelled && modalId === 'foundationCustomerSelectionModal') {
                this.$emit('pushProjectCancelled');
            }
        },
        pushToFoundation() {
            let self = this;

            self.closeFoundationModal('foundationCustomerSelectionModal');
            $('.foundation-project-loader').show();

            let data = {
                projectId: self.project.id,
                contact: self.selectedCustomerForFoundationJob,
                pushWithContact: self.pushCustomerToFoundation,
                customJobNumber: self.customJobNumber,
                foundationJobNumberCustomFieldId: self.foundationJobNumberCustomFieldId,
                isProjectSequentialIdMappedToFoundation: self.isProjectSequentialIdMappedToFoundation,
                selectedCustomerData: self.selectedCustomerData,
                pushSyncedOtherContact: self.pushSyncedOtherContact,
                syncedOtherCompanyContact: self.syncedOtherCompanyContact
            };

            axios.post(route('api.project.foundation.push-project-to-foundation'), data).then((response) => {
                $('.foundation-project-loader').hide();
                if(response.data.status === "success") {
                    self.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    setTimeout(() => {
                        window.location.reload();
                    }, 3000)
                }
                else {
                    self.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                }
            }).catch((error) => {
                $('.foundation-project-loader').hide();
                self.getToast().fire({
                    type: 'error',
                    title: 'Some error occurred!'
                });
            });
        },
        updateJobOnFoundation() {
            let self = this;

            self.closeFoundationModal('updateFoundationJobModal');
            $('.foundation-project-loader').show();

            axios.post(route('api.project.foundation.update-project-to-foundation'), {projectId: this.project.id}).then((response) => {
                $('.foundation-project-loader').hide();
                if(response.data.status === 'success') {
                    self.closeFoundationModal('updateFoundationJobModal');
                    self.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    setTimeout(() => {
                        window.location.reload();
                    }, 3000)
                }
                else {
                    self.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                }
            }).catch((error) => {
                $('.foundation-project-loader').hide();
                self.getToast().fire({
                    type: 'error',
                    title: 'Some error occurred!'
                });
            });

        },
        onSyncFoundationInput(value) {
            if(value.length >= 3) {
                this.fetchingFoundationJobs = true;
                this.debouncedFilterOptions(value);
            }
        },
        filterOptions(input) {
            let self = this;
            axios.post(route('api.project.foundation.search-job-from-foundation'), {search: input}).then((response) => {
                self.fetchingFoundationJobs = false;
                if(response.data.status === 'success') {
                    self.jobsFromFoundation = response.data.jobs;
                }
                else {
                    self.getToast().fire({type: 'error',title: response.data.message});
                }
            }).catch((error) => {
                self.fetchingFoundationJobs = false;
                self.getToast().fire({
                    type: 'error',
                    title: 'Some error occurred!'
                });
            });
        },
        pullJobFromFoundation() {
            let self = this;

            $('.foundation-project-loader').show();
            self.closeFoundationModal('syncFoundationJobConfirmModal');
            self.closeFoundationModal('syncJobFromFoundationModal');

            let data = {
                projectId: this.project.id,
                agaveJobId: this.selectedFoundationJob ? this.selectedFoundationJob.id : null
            };

            axios.post(route('api.project.foundation.sync-project-from-foundation'), data).then((response) => {
                $('.foundation-project-loader').hide();
                self.syncFromFoundationStepTwo = false;
                self.selectedFoundationJob = null;
                self.jobsFromFoundation = [];

                if(response.data.status === 'success') {
                    self.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    setTimeout(() => {
                        window.location.reload();
                    }, 3000)
                }
                else {
                    self.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                }
            }).catch((e) => {
                self.syncFromFoundationStepTwo = false;
                self.selectedFoundationJob = null;
                self.jobsFromFoundation = [];

                self.getToast().fire({
                    type: 'error',
                    title: 'Some error occurred!'
                });
            });
        },
        linkJobForChangeOrdersFromFoundation() {
            let self = this;
            $('.foundation-project-loader').show();
            let data = {
                projectId: this.project.id,
                agaveJobId: this.selectedFoundationJobForChangeOrders ? this.selectedFoundationJobForChangeOrders.id : null,
                vistaJobId: this.selectedFoundationJobForChangeOrders ? this.selectedFoundationJobForChangeOrders.number : null,
            }

            axios.post(route('api.project.vista.link-project-from-vista'), data).then((response) => {
                $('.foundation-project-loader').hide();
                self.jobChangeOrders = response.data;
                self.closeFoundationModal('syncJobFromFoundationForChangeOrderModal');
                self.openFoundationModal('syncFoundationChangeOrderModal');
            });
        },
        fetchJobChangeOrders() {
            let self = this;
            self.isFetchingJobChangeOrders = true;
            $('.foundation-project-loader').show();
            let data = {
                projectId: this.project.id,
                agaveFoundationJobId: this.project && this.project.agave_foundation_project_no ? this.project.agave_foundation_project_no : (this.selectedFoundationJobForChangeOrders ? this.selectedFoundationJobForChangeOrders.id : null),
            };

            self.getToast().fire({
                type: 'success',
                title: "Fetching change orders from Foundation"
            });
            axios.post(route('api.project.foundation.get-project-change-orders-from-foundation'), data).then((response) => {
                $('.foundation-project-loader').hide();
                self.isFetchingJobChangeOrders = false;
                self.jobChangeOrders = response.data;
                self.openFoundationModal('syncFoundationChangeOrderModal')
            }).catch((error) => {
                $('.foundation-project-loader').hide();
                self.isFetchingJobChangeOrders = false;
            });
        },
        syncJobChangeOrder() {
            let self = this;
            $('.foundation-project-loader').show();
            self.closeFoundationModal('syncJobFromFoundationForChangeOrderModal');
            self.closeFoundationModal('updateFoundationSyncedChangeOrderConfirmModal');

            let data = {
                projectId: this.project.id,
                selectedChangeOrder: this.selectedFoundationChangeOrder ?? null,
                selectedProjectChangeOrderIndex: this.selectedProjectChangeOrderIndex ?? null,
                projectChangeOrder: this.$parent.change_orders[this.selectedProjectChangeOrderIndex] ?? null
            };

            axios.post(route('api.project.foundation.sync-project-change-orders-from-foundation'), JSON.stringify(data)).then((response) => {
                $('.foundation-project-loader').hide();
                if(response.data.status === 'success') {
                    self.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    setTimeout(() => {
                        window.location.reload();
                    }, 3000)
                }
                else{
                    self.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                }
            }).catch((error) => {
                self.getToast().fire({
                    type: 'error',
                    title: 'Some error occurred!'
                });
            });
        },
        checkCustomerFoundationStatus() {
            if((this.selectedCustomerForFoundationJob.is_contact_residential && !this.hasFoundationResidentialContactMapping) ||
                (!this.selectedCustomerForFoundationJob.is_contact_residential && !this.hasFoundationCompanyContactMapping)) {
                this.openFoundationModal('pushProjectWithOutCompanyModal');
            }
            else {
                this.pushCustomerToFoundation = false;
                this.proceedPushToFoundation();
            }
        },
        pushProjectWithCustomer(val) {
            this.pushCustomerToFoundation = val;
            this.pushToFoundation();
        },
        async proceedPushToFoundation() {
            this.updateCustomerContactInfo = false;

            if(this.selectedCustomerForFoundationJob.agave_foundation_customer_contact_no) {
                this.pushCustomerToFoundation = true;
                this.pushToFoundation();
            }
            else if(this.selectedCustomerForFoundationJob.is_contact_residential) {
                this.pushCustomerToFoundation = true;
                await this.checkContactEmailDomainExistsOnFoundation(this.selectedCustomerForFoundationJob);
                if(!this.isCustomerEmailDomainExistsOnFoundation && this.foundationResidentialContactCustomerCodeCustomField && this.foundationResidentialContactCustomerCodeCustomField.follow_up_field) {
                    this.selectedCustomerData.customFieldId = this.foundationResidentialContactCustomerCodeCustomField.follow_up_field;
                    this.selectedCustomerData.customFieldLabel = this.foundationResidentialContactCustomerCodeCustomField.follow_up_field_label;
                    this.selectedCustomerData.isResidentialContact = true;
                    await this.getCustomerCustomFieldValue({customFieldId: this.foundationResidentialContactCustomerCodeCustomField.follow_up_field, dataId: this.selectedCustomerForFoundationJob.id}, false);
                    this.selectedCustomerData.customFieldValue = this.foundationResidentialContactCustomerCodeCustomFieldValue;
                    this.openFoundationModal('customerCustomFieldNoModal');
                }
                else {
                    this.pushToFoundation();
                }
            }
            else {
                if(this.selectedCustomerForFoundationJob.is_other_contact_synced_with_foundation) {
                    this.openFoundationModal('updateFoundationSyncedCustomerConfirmModal');
                }
                else {
                    this.pushCustomerToFoundation = true;
                    await this.checkContactEmailDomainExistsOnFoundation(this.selectedCustomerForFoundationJob);
                    if(!this.isCustomerEmailDomainExistsOnFoundation && this.foundationCompanyCustomerCodeCustomField && this.foundationCompanyCustomerCodeCustomField.follow_up_field) {
                        this.selectedCustomerData.customFieldId = this.foundationCompanyCustomerCodeCustomField.follow_up_field;
                        this.selectedCustomerData.customFieldLabel = this.foundationCompanyCustomerCodeCustomField.follow_up_field_label;
                        this.selectedCustomerData.isResidentialContact = false;
                        await this.getCustomerCustomFieldValue({customFieldId: this.foundationCompanyCustomerCodeCustomField.follow_up_field, dataId: this.selectedCustomerForFoundationJob.company_id}, true);
                        this.selectedCustomerData.customFieldValue = this.foundationCompanyCustomerCodeCustomFieldValue;
                        this.openFoundationModal('customerCustomFieldNoModal');
                    }
                    else {
                        this.pushToFoundation();
                    }
                }
            }
        },
        async checkJobNoExistsOnFoundation(jobNumber) {
            let self = this;

            $('.foundation-project-loader').show();

            await axios.post(route('api.project.foundation.check-job-exists-in-foundation'), {jobNumber}).then((data) => {
                $('.foundation-project-loader').hide();
                self.checkJobNumberExistsOnFoundation = data.data.status;
            }).catch((error) => {
                $('.foundation-project-loader').hide();
            });
        },
        async updateSyncedCustomerOnFoundation() {
            this.pushCustomerToFoundation = true;
            this.selectedCustomerData.action = 'update';
            if(this.foundationCompanyCustomerCodeCustomField && this.foundationCompanyCustomerCodeCustomField.follow_up_field) {
                this.selectedCustomerData.customFieldId = this.foundationCompanyCustomerCodeCustomField.follow_up_field;
                this.selectedCustomerData.customFieldLabel = this.foundationCompanyCustomerCodeCustomField.follow_up_field_label;
                this.selectedCustomerData.isResidentialContact = false;
                await this.getCustomerCustomFieldValue({customFieldId: this.foundationCompanyCustomerCodeCustomField.follow_up_field, dataId: this.selectedCustomerForFoundationJob.company_id}, true);
                this.selectedCustomerData.customFieldValue = this.foundationCompanyCustomerCodeCustomFieldValue;
                this.openFoundationModal('customerCustomFieldNoModal');
            }
            else {
                this.pushToFoundation();
            }
        },
        async checkContactEmailDomainExistsOnFoundation(contact) {
            let self = this;

            await axios.post(route('api.customer.foundation.check-email-domain-exists-in-foundation'), {contact}).then((response) => {
                self.isCustomerEmailDomainExistsOnFoundation = response.data.status;
            }).catch((error) => {
                self.isCustomerEmailDomainExistsOnFoundation = false;
            });
        },
        syncedOtherCompanyContactToFoundation() {
            this.pushCustomerToFoundation = true;
            this.pushSyncedOtherContact = true;
            this.pushToFoundation();
        },
        selectedCustomerForFoundationJobChanged() {
            this.pushSyncedOtherContact = false;
            this.syncedOtherCompanyContact = null;
            if(this.selectedCustomerForFoundationJob.is_other_contact_synced_with_foundation) {
                this.syncedOtherCompanyContact = this.selectedCustomerForFoundationJob.other_synced_contact_with_foundation;
            }
            else {
                this.syncedOtherCompanyContact = null;
            }
        },
        async getCustomerCustomFieldValue(data, isCompany = true) {
            let self = this;

            await axios.post(route('api.customer.foundation.get-customer-custom-field-value'), {data, isCompany}).then((response) => {
                if(isCompany) {
                    self.foundationCompanyCustomerCodeCustomFieldValue = response.data.value;
                }
                else {
                    self.foundationResidentialContactCustomerCodeCustomFieldValue = response.data.value;
                }
            }).catch((error) => {
                //
            });
        },
    }
}
</script>
<style scoped>
.custom-tooltip{
    pointer-events: all !important;
}
</style>
